import { misc } from 'chaoskit/src/assets/styles/utility'
import { useField } from 'formik'

const BotField = (props) => {
  const [field] = useField(props)

  return <input {...field} autoComplete="new-password" css={[misc.hide]} />
}

export default BotField
